module.exports = __webpack_public_path__ + "media/assets/img/flags/fi-FI-02e75e392ab5d5a8ed5ab4f8fcae9c77.png";